import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { toast } from 'react-toastify';
import { FiCalendar, FiMail, FiLock } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';

const Login = () => {
  const { login } = useAuth();
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    email: '',
    matKhau: ''
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem('session_expired')) {
      sessionStorage.removeItem('session_expired');
      toast.warn(t('auth.sessionExpired'));
    }
  }, [t]);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const result = await login(formData.email, formData.matKhau);
      if (result.success) {
        toast.success(t('auth.loginSuccess'));
      } else {
        toast.error(result.message || t('auth.loginFailed'));
      }
    } catch (error) {
      toast.error(error.response?.data?.message || t('auth.errorOccurred'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-box">
        <div className="auth-logo">
          <h1>
            <FiCalendar style={{ animation: 'bounce 2s ease-in-out infinite' }} />
            {t('auth.loginTitle')}
          </h1>
          <p>{t('auth.loginSubtitle')}</p>
        </div>

        <form className="auth-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label>
              <FiMail />
              {t('auth.email')}
            </label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder={t('auth.emailPlaceholder')}
              required
            />
          </div>

          <div className="form-group">
            <label>
              <FiLock />
              {t('auth.password')}
            </label>
            <input
              type="password"
              name="matKhau"
              value={formData.matKhau}
              onChange={handleChange}
              placeholder={t('auth.passwordPlaceholder')}
              required
            />
          </div>

          <button type="submit" className="btn btn-primary" disabled={loading}>
            {loading ? (
              <>
                <div style={{
                  width: '20px',
                  height: '20px',
                  border: '2px solid rgba(255, 255, 255, 0.3)',
                  borderTop: '2px solid white',
                  borderRadius: '50%',
                  animation: 'spin 1s linear infinite',
                  marginRight: '8px'
                }}></div>
                {t('auth.processing')}
              </>
            ) : (
              t('auth.loginBtn')
            )}
          </button>
        </form>

        <div className="auth-footer">
          <p>
            {t('auth.noAccount')}
            <Link to="/register" style={{
              color: 'var(--primary-color)',
              fontWeight: '600',
              textDecoration: 'none',
              marginLeft: '4px',
              transition: 'var(--transition)'
            }}>
              {t('auth.registerLink')}
            </Link>
          </p>
          <p style={{ marginTop: '12px' }}>
            <Link to="/" style={{
              color: 'var(--text-secondary)',
              fontWeight: '500',
              textDecoration: 'none',
              fontSize: '14px'
            }}>
              ← {t('landing.backHome')}
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;
